import {clsx} from '@gfiber/typesmith';
import type React from 'react';
import styles from './Typography.module.scss';

type Variant =
  | 'headline1'
  | 'headline2'
  | 'headline3'
  | 'headline4'
  | 'headline5'
  | 'headline6'
  | 'subtitle1'
  | 'subtitle2'
  | 'body1'
  | 'body2'
  | 'caption'
  | 'button'
  | 'overline';

interface TypographyProps extends React.AllHTMLAttributes<HTMLElement> {
  use?: Variant;
  tag?: React.ElementType;
}

const defaultTagMap: Record<Variant, React.ElementType> = {
  headline1: 'h1',
  headline2: 'h2',
  headline3: 'h3',
  headline4: 'h4',
  headline5: 'h5',
  headline6: 'h6',
  subtitle1: 'h6',
  subtitle2: 'h6',
  body1: 'p',
  body2: 'p',
  caption: 'span',
  button: 'span',
  overline: 'span',
};

const Typography = ({
  use = 'body1',
  tag,
  className,
  children,
  ...rest
}: TypographyProps): React.JSX.Element => {
  const Component = tag || defaultTagMap[use] || 'span';

  const classNames = clsx(
    styles.typography,
    styles[`typography--${use}`],
    className,
  );

  return (
    <Component
      className={classNames}
      {...(rest as React.HTMLAttributes<HTMLElement>)}
    >
      {children}
    </Component>
  );
};

export {Typography, type TypographyProps, type Variant};
